import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { LOGO_VIEWBOX, LOGO_WORD, LOGO_CAPTION, LOGO_CORNER } from "@/components/logoPaths";

const KEY = "thrive-intro-seen";
export const INTRO_S = 1.6;

export function shouldPlayIntro() {
  if (typeof window === "undefined") return false;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return false;
  return !window.sessionStorage.getItem(KEY);
}

export default function BrandIntro() {
  const [show, setShow] = useState(shouldPlayIntro);

  useEffect(() => {
    if (!show) return undefined;
    window.sessionStorage.setItem(KEY, "1");
    const t = setTimeout(() => setShow(false), INTRO_S * 1000);
    return () => clearTimeout(t);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="brand-intro"
          className="fixed inset-0 z-[100] flex items-center justify-center bg-navy"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
          aria-hidden="true"
        >
          <motion.svg
            viewBox={LOGO_VIEWBOX}
            className="h-20 w-auto sm:h-28"
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          >
            <path d={LOGO_WORD} fill="#FFFFFF" />
            <motion.path
              d={LOGO_CAPTION}
              fill="#D4AF37"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.5 }}
            />
            {LOGO_CORNER.map(([x, y, w, h], i) => (
              <motion.rect
                key={i}
                x={x}
                y={y}
                width={w}
                height={h}
                fill="#F0A31E"
                initial={{ opacity: 0, scale: 0.6 }}
                animate={{ opacity: 1, scale: 1 }}
                style={{ transformOrigin: "1690px 235px" }}
                transition={{ duration: 0.5, delay: 0.55 + i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              />
            ))}
          </motion.svg>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
